import { SuggestionKind } from 'owa-search-service';

export default function getSupportedSuggestionKinds(): SuggestionKind[] {
    // this is where we tell 3S what kind of suggestions we want back,
    // but 3S tailors the actual suggestions to your SearchScenarioId so we need to onboard spaces with
    // them before this is respected

    return [SuggestionKind.Keywords, SuggestionKind.People, SuggestionKind.Category];
}
